module.exports = __webpack_public_path__ + "static/media/3.52d4699e.mp3";